import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video"
export default class extends Controller {
  static values = {
    title: String,
    thumbnail: String
  }

  connect() {
    this.setupMediaSession()
    this.element.addEventListener('play', () => this.updateMediaSession())
    this.element.addEventListener('pause', () => this.updatePlaybackState())
    this.element.addEventListener('video:refresh', () => this.restart())
  }

  setupMediaSession() {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', () => {
        this.element.play()
      })

      navigator.mediaSession.setActionHandler('pause', () => {
        this.element.pause()
      })

      navigator.mediaSession.setActionHandler('seekbackward', (details) => {
        this.element.currentTime = Math.max(this.element.currentTime - (details.seekOffset || 10), 0)
      })

      navigator.mediaSession.setActionHandler('seekforward', (details) => {
        this.element.currentTime = Math.min(this.element.currentTime + (details.seekOffset || 10), this.element.duration)
      })
    }
  }

  updateMediaSession() {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: this.titleValue || 'Story Tempus Video',
        artist: 'Story Tempus',
        album: 'Story Tempus',
        artwork: [
          {
            src: this.thumbnailValue || '/android-chrome-192x192.png',
            sizes: '192x192',
            type: 'image/png'
          },
          {
            src: this.thumbnailValue || '/android-chrome-512x512.png',
            sizes: '512x512',
            type: 'image/png'
          }
        ]
      })

      navigator.mediaSession.playbackState = 'playing'
    }
  }

  updatePlaybackState() {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.playbackState = 'paused'
    }
  }

  restart() {
    console.log('Restarting video - refreshing and resuming playback')

    // Save current playback position and state
    const currentTime = this.element.currentTime
    const wasPlaying = !this.element.paused

    // Store these for the resume logic
    this.savedTime = currentTime
    this.wasPlayingBeforeHidden = wasPlaying

    // Pause the video first
    this.element.pause()

    // Reload the video source
    this.element.load()

    // Wait for video metadata to be loaded (happens earlier than loadeddata)
    const onLoadedMetadata = () => {
      console.log('Video reloaded, restoring position to:', currentTime)

      // Restore the playback position
      this.element.currentTime = currentTime

      // Resume playback if it was playing before
      if (wasPlaying) {
        // Use a promise-based approach for better error handling
        const playPromise = this.element.play()
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('Playback resumed successfully after restart')
            })
            .catch(error => {
              console.log('Play after restart failed (may need user interaction):', error)
              // Don't set needsReload here, as the video is already reloaded
              // User can manually press play if needed
            })
        }
      }

      this.element.removeEventListener('loadedmetadata', onLoadedMetadata)
    }

    this.element.addEventListener('loadedmetadata', onLoadedMetadata)
  }
}



// import { Controller } from "@hotwired/stimulus"
//
// // Connects to data-controller="video"
// export default class extends Controller {
//   static values = {
//     title: String,
//     thumbnail: String
//   }
//
//   connect() {
//     this.wasPlayingBeforeHidden = false
//     this.savedTime = 0
//     this.timeHidden = null
//     this.needsReload = false
//     this.playAttemptTimeout = null
//     this.setupMediaSession()
//     this.setupVisibilityHandlers()
//     this.element.addEventListener('play', () => this.handlePlay())
//     this.element.addEventListener('pause', () => this.handlePause())
//     this.element.addEventListener('playing', () => this.handlePlaying())
//     this.element.addEventListener('waiting', () => this.handleWaiting())
//     this.element.addEventListener('error', () => this.handleError())
//     this.element.addEventListener('video:refresh', () => this.restart())
//   }
//
//   disconnect() {
//     if (this.visibilityHandler) {
//       document.removeEventListener('visibilitychange', this.visibilityHandler)
//     }
//     if (this.playAttemptTimeout) {
//       clearTimeout(this.playAttemptTimeout)
//     }
//   }
//
//   setupVisibilityHandlers() {
//     this.visibilityHandler = () => {
//       if (document.hidden) {
//         // Page is being backgrounded - save state
//         this.wasPlayingBeforeHidden = !this.element.paused
//         this.savedTime = this.element.currentTime
//         this.timeHidden = Date.now()
//         console.log('Page hidden - saving state:', { playing: this.wasPlayingBeforeHidden, time: this.savedTime })
//
//         // Don't interfere with playback - let it continue in background
//       } else {
//         // Page is being foregrounded
//         const hiddenDuration = this.timeHidden ? (Date.now() - this.timeHidden) / 1000 : 0
//         console.log('Page visible - hidden for:', hiddenDuration, 'seconds')
//
//         // Only flag for reload if:
//         // 1. Was hidden for a very long time (5+ minutes)
//         // 2. AND video is currently paused (not still playing)
//         if (hiddenDuration > 300 && this.element.paused) {
//           console.log('Very long background period detected while paused, flagging for reload')
//           this.needsReload = true
//         }
//
//         // Only try to resume if it was playing before AND is now paused
//         // Don't interfere if it's still playing from background
//         if (this.wasPlayingBeforeHidden && this.element.paused) {
//           this.attemptResume()
//         }
//
//         this.timeHidden = null
//       }
//     }
//
//     document.addEventListener('visibilitychange', this.visibilityHandler)
//   }
//
//   handlePlay() {
//     console.log('Play event triggered, needsReload:', this.needsReload)
//
//     // Clear any existing timeout
//     if (this.playAttemptTimeout) {
//       clearTimeout(this.playAttemptTimeout)
//     }
//
//     // If we need to reload (after long background), do it now
//     if (this.needsReload) {
//       console.log('Reloading video due to long background period')
//       const currentTime = this.element.currentTime
//
//       // Pause first to prevent race conditions
//       this.element.pause()
//       this.element.load()
//
//       const onLoadedData = () => {
//         console.log('Video reloaded, restoring position to:', currentTime)
//         this.element.currentTime = currentTime
//
//         // Try to play after a brief delay
//         setTimeout(() => {
//           const playPromise = this.element.play()
//           if (playPromise !== undefined) {
//             playPromise.catch(error => {
//               console.log('Play after reload failed:', error)
//             })
//           }
//         }, 100)
//
//         this.element.removeEventListener('loadeddata', onLoadedData)
//         this.needsReload = false
//       }
//
//       this.element.addEventListener('loadeddata', onLoadedData)
//     } else {
//       // Only set a timeout if page is visible
//       // Don't interfere with background/lock screen playback
//       if (!document.hidden) {
//         // Set a timeout to detect if video doesn't start playing
//         this.playAttemptTimeout = setTimeout(() => {
//           if (this.element.paused && !document.hidden) {
//             console.log('Video failed to start playing, setting reload flag')
//             this.needsReload = true
//             // Try to play again which will trigger reload
//             this.element.play()
//           }
//         }, 3000) // Increased to 3 seconds
//       }
//
//       this.updateMediaSession()
//     }
//   }
//
//   handlePlaying() {
//     console.log('Video is now playing')
//     this.needsReload = false
//
//     // Clear the timeout since video is playing successfully
//     if (this.playAttemptTimeout) {
//       clearTimeout(this.playAttemptTimeout)
//       this.playAttemptTimeout = null
//     }
//   }
//
//   handlePause() {
//     this.updatePlaybackState()
//
//     // Clear timeout when paused
//     if (this.playAttemptTimeout) {
//       clearTimeout(this.playAttemptTimeout)
//       this.playAttemptTimeout = null
//     }
//   }
//
//   handleWaiting() {
//     console.log('Video is waiting/buffering')
//   }
//
//   handleError() {
//     // Only flag for reload if we're in foreground
//     // Background errors are often spurious and shouldn't trigger reload
//     if (!document.hidden) {
//       console.log('Video error occurred, setting reload flag')
//       this.needsReload = true
//     } else {
//       console.log('Video error occurred in background, ignoring')
//     }
//   }
//
//   attemptResume() {
//     console.log('Attempting to resume playback')
//
//     // Restore time position
//     if (this.savedTime > 0 && Math.abs(this.element.currentTime - this.savedTime) > 1) {
//       this.element.currentTime = this.savedTime
//     }
//
//     // If we need reload, it will happen on play event
//     // Otherwise just try to play
//     const playPromise = this.element.play()
//     if (playPromise !== undefined) {
//       playPromise.catch(error => {
//         console.log('Resume play failed:', error)
//         // Set flag to reload on next play attempt
//         this.needsReload = true
//       })
//     }
//   }
//
//   setupMediaSession() {
//     if ('mediaSession' in navigator) {
//       navigator.mediaSession.setActionHandler('play', () => {
//         this.element.play()
//       })
//
//       navigator.mediaSession.setActionHandler('pause', () => {
//         this.element.pause()
//       })
//
//       navigator.mediaSession.setActionHandler('seekbackward', (details) => {
//         this.element.currentTime = Math.max(this.element.currentTime - (details.seekOffset || 10), 0)
//       })
//
//       navigator.mediaSession.setActionHandler('seekforward', (details) => {
//         this.element.currentTime = Math.min(this.element.currentTime + (details.seekOffset || 10), this.element.duration)
//       })
//     }
//   }
//
//   updateMediaSession() {
//     if ('mediaSession' in navigator) {
//       navigator.mediaSession.metadata = new MediaMetadata({
//         title: this.titleValue || 'Story Tempus Video',
//         artist: 'Story Tempus',
//         album: 'Story Tempus',
//         artwork: [
//           {
//             src: this.thumbnailValue || '/android-chrome-192x192.png',
//             sizes: '192x192',
//             type: 'image/png'
//           },
//           {
//             src: this.thumbnailValue || '/android-chrome-512x512.png',
//             sizes: '512x512',
//             type: 'image/png'
//           }
//         ]
//       })
//
//       navigator.mediaSession.playbackState = 'playing'
//     }
//   }
//
//   updatePlaybackState() {
//     if ('mediaSession' in navigator) {
//       navigator.mediaSession.playbackState = 'paused'
//     }
//   }
//
//   restart() {
//     console.log('Restarting video - refreshing and resuming playback')
//
//     // Save current playback position and state
//     const currentTime = this.element.currentTime
//     const wasPlaying = !this.element.paused
//
//     // Store these for the resume logic
//     this.savedTime = currentTime
//     this.wasPlayingBeforeHidden = wasPlaying
//
//     // Pause the video first
//     this.element.pause()
//
//     // Reload the video source
//     this.element.load()
//
//     // Wait for video metadata to be loaded (happens earlier than loadeddata)
//     const onLoadedMetadata = () => {
//       console.log('Video reloaded, restoring position to:', currentTime)
//
//       // Restore the playback position
//       this.element.currentTime = currentTime
//
//       // Resume playback if it was playing before
//       if (wasPlaying) {
//         // Use a promise-based approach for better error handling
//         const playPromise = this.element.play()
//         if (playPromise !== undefined) {
//           playPromise
//             .then(() => {
//               console.log('Playback resumed successfully after restart')
//             })
//             .catch(error => {
//               console.log('Play after restart failed (may need user interaction):', error)
//               // Don't set needsReload here, as the video is already reloaded
//               // User can manually press play if needed
//             })
//         }
//       }
//
//       this.element.removeEventListener('loadedmetadata', onLoadedMetadata)
//     }
//
//     this.element.addEventListener('loadedmetadata', onLoadedMetadata)
//   }
// }
